import Layers from "slotworks/graphics/layers/layers";
import AbstractRadioControl from "slotworks/smart-ui/controls/abstract/abstract-radio-control";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import betModel from "slotworks/model/bets/bet-model";
import BetModel from "slotworks/model/bets/bet-model";

export default class TotalCreditsRadioControl extends AbstractRadioControl implements Control {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);
        this.setEnabled(true);
    }

    public updateOptions(options: ControlOptions) {
        super.updateOptions(options);

        this.updateValues(options.getTotalCreditValues(), options.creditsPerLine.currentValue * options.selectedLines);

        if (BetModel.freeBet) {
            this.radioGroup.setEnabled(false);
        } else {
            this.radioGroup.setEnabled(this.enabled);
        }
    }

    protected onChangeHandler = (value: number) => {
        const options = new ControlOptions();
        options.creditsPerLine.currentValue = value / this.options.selectedLines;

        this.onChange.dispatch(options);
    }
    public setEnabled(enabled: boolean) {
        super.setEnabled(enabled);

        // Never enable stepper during free bets
        if (betModel.freeBet) {
            this.smartUIGroup.setEnabled(false);
        }
    }
}
